import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  // Close on Escape key
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
    }
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-182">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" data-id="element-183">
            {/* Modal Content */}
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} onClick={e => e.stopPropagation()} // Prevent closing when clicking inside
        className="bg-night-400 border border-night-300 w-full max-w-2xl max-h-[80vh] rounded-2xl shadow-2xl flex flex-col relative overflow-hidden" data-id="element-184">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-night-300 bg-night-400 sticky top-0 z-10" data-id="element-185">
                <h2 className="font-serif text-2xl text-night-50" data-id="element-186">{title}</h2>
                <button onClick={onClose} className="p-2 rounded-full hover:bg-night-300 text-night-100 hover:text-amber-warm transition-colors" aria-label="Cerrar" data-id="element-187">
                  <X className="w-6 h-6" data-id="element-188" />
                </button>
              </div>

              {/* Scrollable Body */}
              <div className="p-6 overflow-y-auto text-night-100 space-y-4 leading-relaxed custom-scrollbar" data-id="element-189">
                {children}
              </div>

              {/* Footer (optional visual fade at bottom if needed, or just padding) */}
              <div className="p-6 border-t border-night-300 bg-night-400/50 text-right" data-id="element-190">
                <button onClick={onClose} className="px-6 py-2 rounded-full bg-night-300 text-night-50 hover:bg-night-200 transition-colors text-sm font-medium" data-id="element-191">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </motion.div>
        </>}
    </AnimatePresence>;
}